import translate from './doctor-filter.language';

class DoctorFilterController {
	constructor() {
		this.translate = translate;
	}

	$onInit() {
		this.sortBy = this.sortBy ? this.sortBy : 'default'; //Initializing the field to sort. Default value is "default".
		this.more = false; //Field to show more section
	}

	/*
     *Change selectedHealthIssue field and call setFilterCallback function.
     */
	changeHealthIssue({id}) {
		this.selectedHealthIssue = id;
		this.setFilterCallback();
	}

	/*
     *Change sortBy field and call sortCallback function.
     */
	changeSortField({id}) {
		this.sortBy = id;
		this.sortCallback();
	}

	/*
     *Change selectedGender field and call setFilterCallback function.
     */
	changeGender({value}) {
		this.selectedGender = value;
		this.setFilterCallback();
	}

	/*
     *Change selectedDateRange field and call setFilterCallback function.
     */
	changeDay({value}) {
		this.selectedDateRange = value;
		this.setFilterCallback();
	}

	/*
     * Show or hide more section
     */
	setMore() {
		this.more = !this.more;
	}

	/*
     * If exist onChangeFilter function, it is called. Passing an object with the filter value.
     */
	setFilterCallback() {
		if (this.onChangeFilter && angular.isFunction(this.onChangeFilter)) {
			this.onChangeFilter({
				$event: {
					selectedDateRange: this.selectedDateRange,
					selectedGender: this.selectedGender,
					selectedHealthIssue: this.selectedHealthIssue,
					selectedLanguage: this.selectedLanguage,
					childrenOption: this.childrenOption,
					timeBeforeOption: this.timeBeforeOption,
					timeAfterOption: this.timeAfterOption
				}
			});
		}
	}

	/*
     *Change advence filter values and call setFilterCallback function.
     */
	advanceFilterOptionsChange({selectedLanguage, timeBeforeOption, timeAfterOption, childrenOption}) {
		this.selectedLanguage = selectedLanguage;
		this.timeBeforeOption = timeBeforeOption;
		this.timeAfterOption = timeAfterOption;
		this.childrenOption = childrenOption;
		this.setFilterCallback();
	}

	/*
     * If exist onChangeSorting function, it is called. Passing two parameters, first the sorting field and second the sorting order.
     */
	sortCallback() {
		if (angular.isFunction(this.onChangeSorting))
			this.onChangeSorting({
				$event: {
					sortBy: this.sortBy
				}
			});
	}

}

export default DoctorFilterController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-filter/doctor-filter.controller.js